// extracted by mini-css-extract-plugin
export var addressFields = "_ju-0";
export var animationContainer = "_ju-1";
export var footer = "_ju-2";
export var lineItems = "_ju-3";
export var modalContent = "_ju-4";
export var orderName = "_ju-5";
export var strong = "_ju-6";
export var warning = "_ju-7";